import { Container, ContainerProps } from "@mantine/core"

import { typeTextContent } from "@tfg/types/endpoints/traceability"

import { i18n } from "~/i18n"

interface Props extends ContainerProps {
  textContent: typeTextContent
}

export const TranslatedTextContent = ({ textContent, ...props }: Props) => {
  const language = i18n.language
  const translation = textContent.TextTranslation.find(
    (translation) => translation.translatedLanguage === language.toUpperCase()
  )?.translation
  return (
    <Container {...props}>
      {translation === undefined || translation === ""
        ? textContent.originalText
        : translation}
    </Container>
  )
}
